module.exports = __webpack_public_path__ + "assets/img/EISS-Super-eBook-w960.67a54e23.webp";